import React, { PureComponent } from "react";
import autoBind from "react-autobind";
import FontAwesome from "react-fontawesome";

class PlayerIcon extends PureComponent {

	constructor(props) {
		super(props);
		autoBind(this);
	}

	render() {
		let { className, style, entity } = this.props;

		let icon;

		if (entity.iconType === "image") {
			icon = <img alt="Player Icon" src={entity.iconImage} />;
		} else if (entity.iconType === "fontAwesome") {
			icon = <FontAwesome name={entity.iconFa} />;	
		}
		let component = <div className={className} style={style}>
			{icon}
		</div>;

		return component;
	}
}

export default PlayerIcon;